import { Component, Vue, Emit } from 'vue-property-decorator';
import { MailWizz } from '@/models/mailwizz/mailwizz';
import { appSettingsModule } from '@/store/app-settings-module';

@Component
export default class MailWizzSelectorComponent extends Vue {
    
    readonly selectListFormatter = (mailWizz: MailWizz) => { return { text: mailWizz.name, value: mailWizz } }
    
    @Emit('loaded')
    notifyLoaded() { }

    get mailWizzes() { return appSettingsModule.allMailWizzInstances }

    get mailWizz() { return appSettingsModule.activeMailWizz }
    set mailWizz(mailWizz: MailWizz) { appSettingsModule.setActiveMailWizzId(mailWizz.id) }

    async mounted() {
        await appSettingsModule.fetchMailWizzInstances()
        if (this.mailWizzes.length == 1) {
            this.mailWizz = this.mailWizzes[0]
        }
        else if (!this.mailWizz) {
            appSettingsModule.setActiveMailWizzFromSession()
        }

        this.notifyLoaded()
    }
}
